export enum LangCode {
    SK = 'sk'
}
